import {Injectable, Injector} from "@angular/core";
import {CleverreportStoreState} from "../cleverreport.store.module";
import {Store} from "@ngrx/store";
import {Observable} from "rxjs/Observable";
import {TemplateEntity} from "./template.entity";
import {TemplateActions} from "./template.actions";
import {DataProvider} from "../../providers/dataprovider/dataprovider";

@Injectable()
export class TemplateService {

  private databaseProvider = null;

  constructor(private store: Store<CleverreportStoreState>, private injector: Injector) {
    setTimeout(() => {
      this.databaseProvider = injector.get(DataProvider);
    })
  }

  addAll(templates: Array<TemplateEntity>, synced: boolean = true): void {
    if (!synced) {
      for (let template of templates) {
        if (!template.hasOwnProperty('_id')) {
          this.databaseProvider.createDocumentWithoutInit(template)
            .then((template: TemplateEntity) => {
              this.store.dispatch(TemplateActions.add(template));
            })
        }
      }
    } else {
      this.store.dispatch(TemplateActions.addAll(templates));
    }
  }

  add(template: TemplateEntity, synced: boolean = true): Promise<TemplateEntity> {
    return new Promise((resolve, reject) => {
      if (!synced) {
        if (!template.hasOwnProperty('_id')) {
          this.databaseProvider.createDocumentWithoutInit(template)
            .then((template: TemplateEntity) => {
              this.store.dispatch(TemplateActions.add(template));
              resolve(template);
            }, () => {
              reject();
            })
        }
      } else {
        this.store.dispatch(TemplateActions.add(template));
        resolve(template);
      }
    });
  }

  set(template: TemplateEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.updateDocument(template);
    }
    this.store.dispatch(TemplateActions.set(template));
  }

  remove(template: TemplateEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.softDeleteDocument(template)
        .then(() => {
          this.store.dispatch(TemplateActions.remove(template._id));
        });
    } else {
      this.store.dispatch(TemplateActions.remove(template._id));
    }
  }

  getById(id: string): Observable<TemplateEntity> {
    return this.store.select('templates').map((templates: Array<TemplateEntity>) => {
      return templates.find((template: TemplateEntity) => {
        return template._id === id;
      });
    });
  }

  getAll(): Observable<Array<TemplateEntity>> {
    return this.store.select('templates')
      .map((templates: Array<TemplateEntity>) => {
        return templates
          .filter((template: TemplateEntity) => {
            return !template.hasOwnProperty('_deleted') && !template.hasOwnProperty('deleted');
          });
      });
  }

}



// WEBPACK FOOTER //
// ./src/store/template/template.service.ts